import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { strip } from './utils';
import { JumpingBeans } from './loadingComponent';
import { reportActions } from '../../store/reportStore';
import { searchActions } from '../../store/searchStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { apiPost, getHostApi } from '../../store/apiWrapper';
import Legend from './legendComponent';
import BbCollapse from './BbCollapse';
import BbCheckbox from '../styling/bbCheckbox';

import AngleDownIcon from '../../img/icons/BBiconsRozbalit';

class BusinessBulletinSection extends React.Component {
    state = {
        isOpen: this.props.isOpen || false,
        isExpandedTouched: false,
        isLoading: false,
        bulletinReportData: undefined
    };

    componentDidMount() {
        if (!isNullOrUndefined(this.props.onClick)) {
            //used for loading subsections that are defined on server
            this.props.onClick();
        }
        this.props.sectionId && this.props.attachSectionElement(this.props.sectionId, this.holder);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isExpandedTouched: false });
        }
        if (this.props.sectionToFocus && this.props.sectionToFocus === this.props.sectionId) {
            this.setState({ isExpandedTouched: true, isOpen: true });
            this.props.sectionFocused();
            this.props.scrollToElement(this.props.elements[this.props.sectionToFocus], true, 'smooth')
        }
    }

    render() {
        const expanded = this.props.resolveExpanded(this.state.isOpen, this.state.isExpandedTouched);

        return (
            <div data-level={this.props.removeDataLevel ? null : (this.props.level || 3)} className={classnames({ 'report-section': true, 'is-expanded': expanded })} style={this.props.style} ref={el => this.holder = el}>
                <div
                    className={classnames('header-wrap', {
                        'header-wrap-circle-icon': localStorage.locales_report_headers_style === 'round' || !this.props.isSection
                    })}
                    onClick={() => this.headerClick()}
                    style={this.props.headerStyle}
                >
                    <div className="header-body">
                        <div className="name">{this.props.name}</div>
                        <div style={{ display: "flex", flex: "1 0", alignItems: "center" }}>
                            {this.state.isLoading && <JumpingBeans />}
                        </div>
                        <div className="bb-chk-pdf-export" style={{ flex: "0 1 auto" }} onClick={(e) => e.stopPropagation()}>
                            <BbCheckbox name={`pdf-id-${this.props.rowNum}`} label={this.props.translate("Common.AddToReport")} id={`pdf-id-${this.props.rowNum}`}
                                value={this.props.search.exportSettings.ids.includes(this.props.bulletinId)}
                                onChange={(v) => v ? this.props.addToPdfExport(this.props.bulletinId) : this.props.removeFromPdfExport(this.props.bulletinId)} />
                        </div>
                        {this.renderIcon(expanded)}
                    </div>
                </div>
                {!this.state.isLoading && this.state.bulletinReportData &&
                    <BbCollapse className='report-section-body' style={this.props.bodyStyle} tag="div" isOpen={expanded} name={this.props.name}>
                        <div>
                            <div className="p-3">
                                <div>
                                    {ReactHtmlParser(this.htmlDecode(this.state.bulletinReportData))}
                                </div>
                            </div>
                        </div>
                    </BbCollapse>
                }
            </div>
        )
    }

    htmlDecode = (input) => {
        var res = strip(input);
        var secondLvl = res.match(/(?!&nbsp;)&(([a-z])\w+);/g);
            if (!isNullOrUndefined(secondLvl) && secondLvl.length > 1)
                return strip(res);
        return res;
    }

    renderIcon = (expanded) => {
        return (
            <div className="icon-wrap">
                {!isNullOrUndefined(this.props.legend && !isNullOrUndefined(this.props.legend.id) && !isNullOrUndefined(this.props.legend.text))
                    ? <span style={{ paddingRight: "0.75em" }}><Legend id={this.props.legend.id}>{this.props.legend.text}</Legend></span>
                    : null}
                <AngleDownIcon
                    style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                    className={classnames('svg-standard-fill', { 'print-hidden': !expanded })} />
            </div>
        )
    }

    headerClick = () => {
        this.setState({ isExpandedTouched: true, isOpen: !this.props.resolveExpanded(this.state.isOpen, this.state.isExpandedTouched) })
        if (!this.state.isOpen && !this.state.bulletinReportData) {
            this.getBulletinReport(this.props.bulletinId)
        }
    }

    getBulletinReport = (bulletinId) => {
        this.setState({ isLoading: true });
        apiPost(`${getHostApi()}/api/search/bulletin-detail/${bulletinId}`, null, null,
            (s) => {
                this.setState({ isLoading: false, bulletinReportData: s.data });
            },
            (e) => this.onError("Common.Error")
        )
    }

    onError = (exception) => {
        this.setState({
            isLoading: false
        });
    }
}

export default withLocalize(connect(
    state => ({ ...state.report, search: state.search }),
    dispatch => bindActionCreators(({ ...reportActions, ...searchActions }), dispatch)
)(BusinessBulletinSection))